var chunkMapping = {
	"169": [
		7169
	],
	"267": [
		6267
	],
	"349": [
		9412
	],
	"431": [
		3431
	],
	"509": [
		8509
	]
};
var idToExternalAndNameMapping = {
	"3431": [
		"default",
		"./MobileStaticHeader",
		1613
	],
	"6267": [
		"default",
		"./DesktopStaticFooter",
		1613
	],
	"7169": [
		"default",
		"./MobileStaticFooter",
		1613
	],
	"8509": [
		"default",
		"./DesktopStaticHeader",
		1613
	],
	"9412": [
		"default",
		"./createBrowserHistory",
		1613
	]
};
var idToRemoteMap = {
	"3431": [
		{
			"externalType": "script",
			"name": "master",
			"externalModuleId": 1613
		}
	],
	"6267": [
		{
			"externalType": "script",
			"name": "master",
			"externalModuleId": 1613
		}
	],
	"7169": [
		{
			"externalType": "script",
			"name": "master",
			"externalModuleId": 1613
		}
	],
	"8509": [
		{
			"externalType": "script",
			"name": "master",
			"externalModuleId": 1613
		}
	],
	"9412": [
		{
			"externalType": "script",
			"name": "master",
			"externalModuleId": 1613
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}